var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 20,
    viewBox: "0 0 81 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68711 2.35293C5.97891 2.35293 7.03067 3.40889 7.03067 4.70585C7.03067 6.00281 5.97891 7.05878 4.68711 7.05878C3.39532 7.05878 2.34356 6.00281 2.34356 4.70585C2.34356 3.40789 3.39532 2.35293 4.68711 2.35293ZM4.68711 0C2.09854 0 0 2.10693 0 4.70585C0 7.30477 2.09854 9.4117 4.68711 9.4117C7.27568 9.4117 9.37422 7.30477 9.37422 4.70585C9.37422 2.10693 7.27568 0 4.68711 0Z",
    fill: "#FF5349"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37422 10.5879H0V12.9408H9.37422V10.5879Z",
    fill: "#FF5349"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37422 17.6465H0V19.9994H9.37422V17.6465Z",
    fill: "#FF5349"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37422 14.1182H0V16.4711H9.37422V14.1182Z",
    fill: "#FF5349"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5089 0H32.8496V19.5934H36.5089V0Z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5153 5.30483C17.104 5.30483 15.7863 5.70682 14.6688 6.4018V0H11.0095V19.5934H14.6688V18.9024C15.7863 19.5974 17.104 19.9994 18.5153 19.9994C22.557 19.9994 25.8338 16.7095 25.8338 12.6516C25.8338 8.59373 22.557 5.30483 18.5153 5.30483ZM18.5153 16.3255C16.4974 16.3255 14.856 14.6775 14.856 12.6516C14.856 10.6257 16.4974 8.97772 18.5153 8.97772C20.5331 8.97772 22.1745 10.6257 22.1745 12.6516C22.1745 14.6775 20.5331 16.3255 18.5153 16.3255Z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.683 8.97857C74.7009 8.97857 76.3423 10.6265 76.3423 12.6525C76.3423 14.6784 74.7009 16.3263 72.683 16.3263C70.6651 16.3263 69.0238 14.6784 69.0238 12.6525C69.0238 10.6265 70.6651 8.97857 72.683 8.97857ZM72.683 5.30469C68.6413 5.30469 65.3645 8.59459 65.3645 12.6525C65.3645 16.7103 68.6413 20.0002 72.683 20.0002C76.7247 20.0002 80.0015 16.7103 80.0015 12.6525C80.0015 8.59359 76.7247 5.30469 72.683 5.30469Z",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1713 5.31055H27.5121V19.5921H31.1713V5.31055Z",
    fill: "#FFFFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3417 3.67388C30.3522 3.67388 31.1713 2.85146 31.1713 1.83694C31.1713 0.822427 30.3522 0 29.3417 0C28.3312 0 27.5121 0.822427 27.5121 1.83694C27.5121 2.85146 28.3312 3.67388 29.3417 3.67388Z",
    fill: "#FFFFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0304 5.30483C49.6191 5.30483 48.3014 5.70682 47.1839 6.4018V0H43.5247V19.5934H47.1839V18.9024C48.3014 19.5974 49.6191 19.9994 51.0304 19.9994C55.0721 19.9994 58.3489 16.7095 58.3489 12.6516C58.3489 8.59373 55.0721 5.30483 51.0304 5.30483ZM51.0304 16.3255C49.0125 16.3255 47.3712 14.6775 47.3712 12.6516C47.3712 10.6257 49.0125 8.97772 51.0304 8.97772C53.0483 8.97772 54.6897 10.6257 54.6897 12.6516C54.6897 14.6775 53.0483 16.3255 51.0304 16.3255Z",
    fill: "#FFFFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6862 5.31055H60.027V19.5921H63.6862V5.31055Z",
    fill: "#FFFFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8566 3.67388C62.8671 3.67388 63.6862 2.85146 63.6862 1.83694C63.6862 0.822427 62.8671 0 61.8566 0C60.8461 0 60.027 0.822427 60.027 1.83694C60.027 2.85146 60.8461 3.67388 61.8566 3.67388Z",
    fill: "#FFFFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0166 19.9991C41.0271 19.9991 41.8463 19.1767 41.8463 18.1621C41.8463 17.1476 41.0271 16.3252 40.0166 16.3252C39.0062 16.3252 38.187 17.1476 38.187 18.1621C38.187 19.1767 39.0062 19.9991 40.0166 19.9991Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/Logo-dark.50589138e8752ad83ee2977ce55b7ccd.svg";
export { ForwardRef as ReactComponent };